import { render, staticRenderFns } from "./CreateSGDbOps.vue?vue&type=template&id=7def5323&scoped=true"
import script from "./CreateSGDbOps.vue?vue&type=script&lang=js"
export * from "./CreateSGDbOps.vue?vue&type=script&lang=js"
import style0 from "./CreateSGDbOps.vue?vue&type=style&index=0&id=7def5323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def5323",
  null
  
)

export default component.exports